/**
 * @file Values that have been hardcoded in src/diagrams/er/styles.js. These can be used by
 *   theme-_._ files to maintain display styles until themes, styles, renderers are revised. --
 *   2022-09-22
 */
export const oldAttributeBackgroundColorOdd = '#ffffff';
export const oldAttributeBackgroundColorEven = '#f2f2f2';
